import Vue from 'vue'

/**
 * Vue ECharts
 * https://github.com/ecomfe/vue-echarts
 *
 * Registramos el componente global de forma asíncrona para que echarts (una
 * librería pesada) salga del bundle inicial y solo se cargue en las vistas que
 * realmente usan <e-charts> (dashboard y reporte de proveedores). La API global
 * del componente se mantiene intacta: las plantillas siguen usando <e-charts>.
 * Los imports de los submódulos echarts/lib/* viven en ./echarts-async para que
 * queden dentro del chunk diferido.
 */
Vue.component('e-charts', () => import(/* webpackChunkName: "echarts" */ './echarts-async'))
